<form autocomplete="off" [formGroup]="innerForm">
    <div class="float-left smart-tag-form-container container" *ngIf="smartTagModel !== null">
        <div class="row" *ngIf="schemaShouldShowComplexForm">
            <div class="col-md-10">
                <div class="custom-control custom-checkbox">
                    <input name="deficiencySeverity" formControlName="deficiencySeverity"
                           type="checkbox"
                           class="custom-control-input"
                           id="deficiencySeverity{{customId}}">
                    <label class="custom-control-label" for="deficiencySeverity{{customId}}">Compromises livability?</label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-10">
                <label>Description:</label>
                <textarea name="description"
                          formControlName="description"
                          (keyup)="smartTagModel.description = $event.currentTarget['value'];"
                          id="report-image-description" name="report-image-description" rows="3"
                          cols="50" [maxLength]="150"></textarea>
            </div>
        </div>
    </div>
</form>
